/*******************************************************************************
MANAGE EMPTY STATE
Figure out if the empty state should be displayed or not.
*******************************************************************************/

export default function manageEmptyState(itemSelector) {
    const numVisibleItems = $(`${itemSelector}:not(.hide-filtertab)`).length;
    const $emptyMessage = $(itemSelector).parent().find('.filter-tab-empty');
    const emptyClass = 'hide-filtertab';

    // Hide the empty message if there are any visible items, otherwise show it
    if (numVisibleItems > 0) {
        $emptyMessage.addClass(emptyClass);
    }
    else {
        $emptyMessage.removeClass(emptyClass);
    }
}
